// Playfair Display is now loaded via nuxt.config.ts head config
// (preconnect + stylesheet link in the initial HTML).
// This plugin is kept as a no-op for backwards compatibility.
export default defineNuxtPlugin(() => {})
